import { render } from "./BasicUsage.vue?vue&type=template&id=d01d2d1a"
import script from "./BasicUsage.vue?vue&type=script&lang=js"
export * from "./BasicUsage.vue?vue&type=script&lang=js"
script.render = render

export default script